<template>
  <div class="flex w-full items-center justify-between">
    <div class="space-y-1">
      <div class="flex items-center gap-3">
        <span
          v-price="currentPrice"
          class="text-text-neutral-primary text-lg font-bold"
        />
        <FavoritesPriceDeltaBadge v-if="priceDelta" :delta="priceDelta" />
      </div>
      <p
        v-if="meta && (meta.dateLine || meta.passengerTotal > 0)"
        class="text-situational-grey mt-1 text-sm"
      >
        <span v-if="meta.dateLine">{{ meta.dateLine }}</span>
        <span v-if="meta.dateLine && meta.passengerTotal > 0"> • </span>
        <span v-if="meta.passengerTotal > 0">{{
          t('passengersData.passenger', { count: meta.passengerTotal })
        }}</span>
        <template v-if="meta.cabinClassKey">
          <span> • </span>
          <span>{{ t(`general.cabinClass.${meta.cabinClassKey}`) }}</span>
        </template>
      </p>
    </div>

    <FavoriteButton
      :is-active="true"
      variant="button"
      class="shrink-0"
      :aria-label="$t('favoritesPage.removeFromFavorites')"
      @toggle="emit('remove', item)"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import {
    FavoriteButton,
    type WatchlistItem,
    getFavoriteSearchMeta,
    getPriceHistoryDelta,
  } from '@/features/favorites';

  import FavoritesPriceDeltaBadge from './FavoritesPriceDeltaBadge.vue';

  const props = defineProps<{
    item: WatchlistItem;
  }>();

  const emit = defineEmits<{
    remove: [item: WatchlistItem];
  }>();

  const { t } = useI18n();

  const currentPrice = computed(() => {
    const { history } = props.item;
    if (history && history.length > 0) {
      const sorted = [...history].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );
      return sorted[0].price;
    }
    return props.item.initial_price;
  });

  const meta = computed(() => getFavoriteSearchMeta(props.item.search_query));

  const priceDelta = computed(() =>
    getPriceHistoryDelta(
      props.item.history,
      props.item.currency,
      props.item.initial_price,
    ),
  );
</script>
